export function createThumbnail(
  file: File,
  maxWidth: number = 200,
  maxHeight: number = 200,
): Promise<ImageInfo> {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = () => {
      let img = new Image()
      img.src = <string>reader.result
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const thumbnailScale =
          img.width / img.height > maxWidth / maxHeight
            ? maxWidth / img.width
            : maxHeight / img.height
        const thumbnailWidth = img.width * thumbnailScale
        const thumbnailHeight = img.height * thumbnailScale

        canvas.width = thumbnailWidth
        canvas.height = thumbnailHeight

        ctx.drawImage(img, 0, 0, thumbnailWidth, thumbnailHeight)
        const base64 = canvas.toDataURL('image/png')
        resolve({
          width: img.width,
          height: img.height,
          thumbnail: base64,
        })
      }
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export interface ImageInfo {
  thumbnail: string
  width: number
  height: number
}
